<template>
  <v-card>
    <v-card-title
      v-text="TITLE"
    />

    <v-card-text>
      <v-row class="mx-0">
        <v-col cols="6">
          <select-project
            v-model="project"
          />
          <file-button
            class="mt-4"
            @file-content="onFileSelected"
          />
        </v-col>

        <v-col cols="6">
          <v-simple-table
            dense
            fixed-header
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Replace From
                  </th>
                  <th class="text-left">
                    Replace To
                  </th>
                  <th class="text-right">
                    <v-icon
                      @click="replacements.push({from: '', to: ''})"
                    >mdi-plus
                    </v-icon>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="_, index in replacements">
                  <tr>
                    <td>
                      <v-text-field
                        v-model="replacements[index].from"
                        hide-details
                        class="mb-2"
                        placeholder="From"
                        dense
                      />
                    </td>
                    <td>
                      <v-text-field
                        v-model="replacements[index].to"
                        hide-details
                        class="mb-2"
                        placeholder="To"
                        dense
                      />
                    </td>
                    <td class="text-right">
                      <v-icon
                        color="error"
                        @click="replacements.splice(index, 1)"
                      >mdi-minus-circle-outline
                      </v-icon>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>

      <p class="mt-4 mb-0">
        Please note that project-specific attributes such as benefits <strong>will not be imported.</strong><br>
        All imported templates should be <strong>reviewed and tested</strong> before they are used in real-world production scenarios.
      </p>
    </v-card-text>

    <v-card-actions class="justify-end">
      <v-btn
        color="error"
        :loading="isLoading"
        @click="$emit('cancel')"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        :disabled="!isValid"
        :loading="isLoading"
        @click="$emit('import', { data: importData, replacements, project, })"
      >
        Import
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
import FileButton from '@/components/core/FileButton.vue';
export default {
  props: {
    isLoading: Boolean,
  },
  components: {
    SelectProject,
    FileButton,
  },
  data() {
    return {
      TITLE: 'Import mail templates',
      project: null,
      replacements: [],
      importData: null,
    }
  },

  computed: {
    isValid() {
      return !!this.project && Array.isArray(this.importData) && !!this.importData.length
    },
  },

  methods: {
    onFileSelected(content) {
      try {
        this.importData = JSON.parse(content)
      } catch {
        this.$showError('Invalid JSON')
      }
    },
  }
}
</script>
